import { Button, Stack } from '@mui/material';
import React from 'react';
import { CustomDialog } from './CustomDialog';

import './DeleteDialog.scss';

interface IProps {
  open: boolean;
  children?: React.ReactElement;
  title: string;
  onDelete: () => void;
  onCancel: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const DeleteDialog: React.FC<IProps> = ({ open, children, title, onDelete, onCancel, maxWidth }) => {
  const [pendingDelete, setPendingDelete] = React.useState<boolean>(false);

  return (
    <CustomDialog
      open={open}
      title={title}
      maxWidth={maxWidth}
      actions={
        <Stack className="psf-dialog-delete__action-container">
          <Button
            sx={{
              background: '#EE0000',
              color: 'white',
            }}
            type="button"
            onClick={() => {
              setPendingDelete(true);
              onDelete();
            }}
            className="psf-dialog-delete__btn"
            disabled={pendingDelete}
          >
            Löschen
          </Button>
          <Button
            variant="text"
            sx={{
              maxWidth: '148px',
              color: 'black',
            }}
            className="psf-dialog-delete__btn"
            onClick={onCancel}
          >
            Abbrechen
          </Button>
        </Stack>
      }
      handleClose={onCancel}
    >
      {children ?? <></>}
    </CustomDialog>
  );
};
